/** W18 GOT Biography (legacy QualityGOT Utility, manual p265–267, screenshot 154627). */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { useAuth } from "@/features/auth/store";
import { GotBiographyPage } from "@/features/got/components/biography-page";

const search = z.object({
  mode: z.enum(["crop-variety", "lot"]).optional(),
  cropId: z.number().int().optional(),
  varietyId: z.number().int().optional(),
  lot: z.string().optional(),
  preview: z.boolean().optional(),
});

export const Route = createFileRoute("/_app/quality/got/biography")({
  validateSearch: search,
  beforeLoad: () => {
    if (!useAuth.getState().can("got.biography")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <GotBiographyPage
      search={s}
      onSearch={(next) => void navigate({ search: next })}
    />
  );
}
